import {
    formatReportCurrency,
    formatReportDateTime,
    formatReportPercent,
    formatReportSmartDateTime,
} from "./fclReportHelpers";

export const pickField = (row, keys, fallback = "") => {
    if (!row) return fallback;
    for (const key of keys) {
        const val = row[key];
        if (val !== null && val !== undefined && val !== "") return val;
    }
    return fallback;
};

export const cell = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return String(value);
};

export const col = (key, label, render, sortable = true, meta = {}) => ({
    key,
    label,
    render,
    sortable,
    fieldKeys: meta.fieldKeys,
    exportValue: meta.exportValue,
    sortValue: (row) => {
        const text = render(row);
        return typeof text === "string" ? text.toLowerCase() : text;
    },
});

export const dateCol = (key, label, fieldKeys) =>
    col(
        key,
        label,
        (row) => formatReportDateTime(pickField(row, fieldKeys)),
        true,
        {
            fieldKeys,
            exportValue: (row) => formatReportDateTime(pickField(row, fieldKeys)),
        }
    );

export const usDateTimeCol = (key, label, fieldKeys) =>
    col(
        key,
        label,
        (row) => formatReportUsDateTime(pickField(row, fieldKeys)),
        true,
        {
            fieldKeys,
            exportValue: (row) => formatReportUsDateTime(pickField(row, fieldKeys)),
        }
    );

export const textCol = (key, label, fieldKeys) =>
    col(key, label, (row) => cell(pickField(row, fieldKeys)), true, {
        fieldKeys,
        exportValue: (row) => cell(pickField(row, fieldKeys)),
    });

export const currencyCol = (key, label, fieldKeys) =>
    col(
        key,
        label,
        (row) => {
            const v = pickField(row, fieldKeys, null);
            return v == null ? "-" : formatReportCurrency(v);
        },
        true,
        {
            fieldKeys,
            exportValue: (row) => {
                const v = pickField(row, fieldKeys, null);
                return v == null ? "-" : formatReportCurrency(v);
            },
        }
    );

export const percentCol = (key, label, fieldKeys) =>
    col(key, label, (row) => formatReportPercent(pickField(row, fieldKeys, null)), true, {
        fieldKeys,
        exportValue: (row) => formatReportPercent(pickField(row, fieldKeys, null)),
    });
